module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop_placeholder_fall2023-77748ebf45b0a7d1394605628a2d9e64.webp";